module.exports = __webpack_public_path__ + "static/media/rage.f54c4b69.jpg";